import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { userAcceptedTermsThunk } from "../../store/thunks";
import { useClearCurrentTopic } from "../../hooks/useClearCurrentTopic";
import LanguageSwitcher from "../common/LanguageSwitcher";
import { getUserData } from "../../store/persistStore";
import constants from "../../utils/constants";
import { trackAdobeAgreeClick } from "../../utils/adobeLogging";

const TermsPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.ui.lang);

  useEffect(() => {
    const agreeHandler = async () => {
      if (window.location.hostname.includes(constants.prodHostName)) {
        const userData = getUserData();
        window.growsumo.data.email = userData.email;
        window.growsumo.data.customer_key = userData.email;
        window.growsumo.createSignup();
      }

      trackAdobeAgreeClick(lang);
      await dispatch(userAcceptedTermsThunk());
      history.push("/app/activity/assessment");
    };

    window.addEventListener("agree", agreeHandler);

    return () => {
      window.removeEventListener("agree", agreeHandler);
    };
  }, []);

  useClearCurrentTopic();
  const page = useSelector((state) => state.pages["TOS"]);

  const getContent = () => {
    return { __html: page ? page.fullContent : "" };
  };

  return (
    <div
      className="font-primary text-base leading-normal text-gray-600 tracking-wide bg-color-main min-h-screen"
      adoberegion="terms"
    >
      <div className="flex justify-center">
        <div className="lg:px-0 px-3 lg:w-1/2 w-2/3">
          <div id="terms-page" className="bg-white shadow rounded p-10 my-10">
            <div className="flex justify-end">
              <LanguageSwitcher redirectTo="/terms" />
            </div>

            {page && <div dangerouslySetInnerHTML={getContent()} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
